import { createSelector } from "reselect";
// COMMENT: state.mainpageというのは
// mainpageというReducerの最上位に君臨するIndex名である
const mainpageSelector = (state) => state.mainpage

export const getProverb = createSelector(
    [mainpageSelector],
    // COMMENT: state.todayProverbというのは
    // mainpageのStateの一つであるtodayProverbのことである
    state => state.todayProverb
)

export const getCounter = createSelector(
    [mainpageSelector],
    // COMMENT: state.todayProverbというのは
    // mainpageのStateの一つであるtodayProverbのことである
    state => state.counter
)